<template>
  <div class="fc-home">
    <Menu></Menu>
    <div class="contest-wrapper">
      <h1>Hey, Your contest created successfully</h1>
      <div class="top-space">
        <button class="confirm-btn" @click="createGame">Yes, I will create a game</button>
        <button class="confirm-btn" @click="goBack">Skip Now</button>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { UserHome, FeaturedContest } from '@/models/fantasyconsole/contest'
import GamePreview from '@/components/fantasygame/GamePreview'
import ContestGames from '@/components/fantasygame/ContestGames'
import Pagination from '@/components/cricket/Pagination'

export default {
  components: {
    GamePreview,
    ContestGames,
    Pagination
  },
  data () {
    return {
      contestKey: this.$route.params.key,
    }
  },
  methods: {
   goBack () {
    this.$router.push({ name: 'FCHome' })
   },
   createGame () {
    this.$router.push({ name: 'FCCreateGame', params: { key: this.contestKey } })
   }
  }
}
</script>
